import http from '@/utils/http'
import convert from '@/utils/model-convert'
import { FormArgument, EmployeeFormArgument } from '@/models/ec-notice'

const EC_NOTICE_URL = '/rest/es/crmcreater/getByUser'
const EC_EMPLOYEE_URL = '/rest/es/crmuser/list4Creater'
const EC_SAVE_URL = '/rest/es/crmcreater/post'

export default {
  getEcNotice ({crmCode}, cb) {
    http.get(EC_NOTICE_URL, {params: {crmCode}}).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  getEmployee ({form}, cb) {
    const params = convert.toJson(form, EmployeeFormArgument)
    http.get(EC_EMPLOYEE_URL, {params}).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  saveEmployee ({form}, cb) {
    let postData = convert.toStringify(form, FormArgument)
    http.post(EC_SAVE_URL, postData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  }
}



// WEBPACK FOOTER //
// ./src/api/client/ec-notice.js